import edit from "../../../../assets/edit.svg";
import del from "../../../../assets/delete.svg";
import "../../../../styles/screens/client-visit-details/manage-module/EventsListTable.css";
import { useDispatch, useSelector } from "react-redux";
import place from "../../../../assets/image-placeholder.png";
import { useState } from "react";
import ConfirmationDialog from "../../../common-components/ConfirmationDialog";
import { deleteResource } from "../../../../slices/ResourcesSlice";
import ResourcesListForm from "./ResourcesListForm";
import { fileDelete } from "../../../../slices/FileUploadSlice";

function ResourcesListTableBody({ dataItem, isVisit }) {
  const dispatch = useDispatch();
  const [showForm, setShowForm] = useState(false);
  const [showDelete, setShowDelete] = useState(false);

  return (
    <>
      <tbody key={dataItem._id}>
        <tr className="event-row">
          <td className="event-title">{dataItem.title}</td>
          <td>{dataItem.description}</td>
          <td>{dataItem.fileType}</td>
          <td>{dataItem.fileName}</td>
          <td className="image-index-container">
            <img
              src={
                dataItem?.fileThumbnailUrl ? dataItem?.fileThumbnailUrl : place
              }
              style={{ width: 80, height: 80 }}
              alt="place"
              onClick={() => {
                window.open(dataItem?.fileUrl, dataItem?.fileName);
              }}
              className="tourist-img"
            />
          </td>
          <td className="event-title">
            {dataItem.isDeleteAllowed ? "Yes" : "No"}
          </td>
          {!isVisit && (
            <td>
              <div className="event-icon">
                <img
                  src={edit}
                  alt="edit"
                  className="icon-middle"
                  onClick={(e) => {
                    setShowForm(true);
                  }}
                />
                <img
                  src={del}
                  alt="delete"
                  className="icon-middle"
                  onClick={() => {
                    setShowDelete(true);
                  }}
                />
              </div>
            </td>
          )}
        </tr>
        <ResourcesListForm
          show={showForm}
          editMode={true}
          onClickNext={() => {
            setShowForm(false);
          }}
          data={dataItem}
        />
        <ConfirmationDialog
          show={showDelete}
          buttonName="Delete"
          onClickHandle={(flag) => {
            if (flag) {
              console.log(dataItem);
              dispatch(deleteResource(dataItem._id));
              if (dataItem?.fileId) {
                dispatch(fileDelete({ id: dataItem.fileId }));
              }
              if (dataItem?.thumbNailId) {
                dispatch(fileDelete({ id: dataItem.thumbNailId }));
              }
            }
            setShowDelete(false);
          }}
          title="Delete a Resource"
          subTitle={`Are you sure you want to delete ${dataItem.title} file`}
        />
      </tbody>
    </>
  );
}

export default ResourcesListTableBody;
